import { mixinPermission } from '@/utils/mixin_permission'
import router from './router'

mixinPermission(router)
